import { PurchasesCommitmentsTab } from "@/components/blocks/purchases/purchases-commitments-tab";

import { useProjectDetailsContext } from "../context";

export function PurchasesTab() {
  const ctx = useProjectDetailsContext();
  // Destructure all needed values from context
  const {
    project, employees,
    numericProjectId,
    // Additional items that may be used
  } = ctx;

  return (
    <>
                <PurchasesCommitmentsTab projectId={numericProjectId} projectCode={project?.code} employees={employees} />

    </>
  );
}
